







import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { IItemGroupSelectBehavior } from "../../../../../documaker/domain/format/objects";

@Component
export default class ItemGroupSelectBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IItemGroupSelectBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IItemGroupSelectBehavior) => T, defaultValue: T) => T;

  get groupName(): string {
    return this.readPropertyOrDefault(s => s.groupName, "");
  }

  set groupName(value: string) {
    this.writePropertyWhenValid(s => s.groupName = value);
  }
}
